import {
  dangerColor,
  successColor,
  textMutedColor
} from "assets/jss/default/theme";

const commonStyles = theme => ({
  row: {
    display: "flex",
    flexWrap: "wrap",
    marginRight: -15,
    marginLeft: -15,
    "&.ng": {
      marginRight: 0,
      marginLeft: 0
    }
  },
  noGutters: {
    marginRight: 0,
    marginLeft: 0,
    "& > $col, & > $colSix": {
      paddingRight: 0,
      paddingLeft: 0
    }
  },
  colAuto: {
    flex: "0 0 auto",
    width: "auto",
    maxWidth: "100%"
  },
  textCenter: {
    textAlign: "center !important"
  },
  textRight: {
    textAlign: "right !important"
  },
  col: {
    flexBasis: 0,
    "-webkit-box-flex": 1,
    flexGrow: 1,
    maxWidth: "100%",
    position: "relative",
    width: "100%",
    paddingRight: 15,
    paddingLeft: 15
  },
  colSix: {
    flex: "0 0 50%",
    maxWidth: "50%"
  },
  colFour: {
    flex: "0 0 25%",
    maxWidth: "50%"
  },
  textMuted: {
    fontWeight: 400,
    color: `${textMutedColor} !important`
  },
  mtFour: {
    marginTop: "1.5rem !important"
  },
  mbFour: {
    marginBottom: "1.5rem !important"
  },
  dangerTextColor: {
    color: theme.palette.error.main
  },
  hide: {
    display: "none"
  },
  formControl: {
    margin: theme.spacing(2),
    minWidth: 240
  },
  verticalAlignTextCenter: {
    display: "flex",
    alignItems: "center"
  },
  errorText: {
    color: theme.palette?.error?.main || dangerColor[0]
  },
  successText: {
    color: theme.palette?.success?.main || successColor[0]
  },
  header: {
    textTransform: "none",
    fontWeight: "bold"
  },
  subHeader: {
    fontSize: 12
  }
});

export default commonStyles;
